import { Actions } from './typesActions';

/**
 * Etat initial
 */
const initialState = {
    items: [],
    isLoading: false
};

/**
 * Reducer pour les types
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        // Fetch Types.
        case Actions.FETCH_TYPES_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case Actions.FETCH_TYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                items: [...action.types]
            };
        case Actions.FETCH_TYPES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };

        default:
    }

    return state;
}

export default reducer;